document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('.navigation_sectiontab a');
  
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function(e) {
        e.preventDefault();
  
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('active');
        }
  
        this.classList.add('active');
  
        var sections = document.querySelectorAll('.tab-content');
        for (var k = 0; k < sections.length; k++) {
          sections[k].style.display = 'none';
        }
  
        var section = document.querySelector(this.getAttribute('href'));
        if (section) {
          section.style.display = 'block';
        }
      });
    }
  });